module.exports = "/_next/static/public/images/12b9f69305508a79b54aa40dc5c6ad09-d1dc9b56b2723aee5ca26f8595aa554a.png";